(function () {
  'use strict';

  var config = window.ClutchWarranty;
  if (!config || !config.variants || !config.variants.length) return;

  var syncInProgress = false;

  function normalizeIds(raw) {
    if (!raw) return [];
    if (Array.isArray(raw)) {
      return raw.map(function (id) {
        return String(id).trim();
      }).filter(Boolean);
    }
    return String(raw).split(',').map(function (id) {
      return id.trim();
    }).filter(Boolean);
  }

  var eligibleProductIds = normalizeIds(config.eligibleProductIds);

  function addEligibleProduct(id) {
    var normalized = String(id).trim();
    if (normalized && eligibleProductIds.indexOf(normalized) === -1) {
      eligibleProductIds.push(normalized);
    }
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer') || document.querySelector('welcome-back-saved-cart');
  }

  function getRequiredTier(chargerCount) {
    var count = parseInt(chargerCount, 10) || 0;
    if (count < 1) return 0;
    return Math.min(count, config.maxTier || config.variants.length);
  }

  function getVariantByTier(tier) {
    if (!tier || tier < 1) return null;
    return config.variants[Math.min(tier, config.variants.length) - 1] || null;
  }

  function isEligibleItem(item) {
    return eligibleProductIds.indexOf(String(item.product_id)) !== -1;
  }

  function isWarrantyItem(item) {
    return String(item.product_id) === String(config.productId);
  }

  function countEligibleChargers(items) {
    return (items || []).reduce(function (total, item) {
      return isEligibleItem(item) ? total + (item.quantity || 0) : total;
    }, 0);
  }

  function getWarrantyState(items) {
    var warrantyItems = (items || []).filter(isWarrantyItem);
    var coverage = 0;

    warrantyItems.forEach(function (item) {
      var matched = config.variants.find(function (variant) {
        return String(variant.id) === String(item.variant_id);
      });
      if (matched) coverage = Math.max(coverage, matched.coverage);
    });

    return {
      lineCount: warrantyItems.length,
      totalLineQty: warrantyItems.reduce(function (sum, item) {
        return sum + (item.quantity || 0);
      }, 0),
      coverage: coverage,
      items: warrantyItems
    };
  }

  function buildVariantUpdates(requiredTier) {
    var updates = {};
    config.variants.forEach(function (variant, index) {
      updates[variant.id] = index === requiredTier - 1 ? 1 : 0;
    });
    return updates;
  }

  function fetchCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      return response.json();
    });
  }

  function applyCartUpdates(updates, cartDrawer) {
    var formData = new FormData();
    formData.append('form_type', 'cart');

    Object.keys(updates).forEach(function (variantId) {
      formData.append('updates[' + variantId + ']', updates[variantId]);
    });

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
    }

    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (response) {
      return response.json();
    });
  }

  function refreshDrawer(data, cartDrawer) {
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(data);
      return;
    }
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'warranty-sync' });
  }

  function trackAttach(variant) {
    if (!variant) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'warranty_attach',
      value: variant.price / 100,
      coverage: variant.coverage
    });
  }

  function showUpsellBanner(chargerCount, cartDrawer) {
    if (!cartDrawer || cartDrawer.tagName === 'WELCOME-BACK-SAVED-CART') return;

    var widget = cartDrawer.querySelector('.warranty-widget-info');
    if (!widget) return;

    var requiredTier = getRequiredTier(chargerCount);
    var variant = getVariantByTier(requiredTier);
    if (!variant) return;

    var infoNode = widget.querySelector('td div');
    var infoWarranty = infoNode ? JSON.parse(infoNode.textContent) : config.variants;
    var info = infoWarranty[requiredTier - 1] || variant;
    var currencySymbol = info.currency_symbol || config.currencySymbol || '$';
    var compareAt = parseInt(info.compare_at_price, 10) || 0;
    var saveHtml = compareAt > variant.price
      ? '<b>Save ' + currencySymbol + ((compareAt - variant.price) / 100).toFixed(2) + '</b>'
      : '';

    cartDrawer.querySelectorAll('.banner-warranty').forEach(function (node) {
      node.remove();
    });

    var banner = document.createElement('div');
    banner.className = 'banner-warranty';
    banner.innerHTML =
      '<div class="banner-container">' +
        '<div class="image"><img src="' + (info.featured_image || '') + '" loading="lazy" alt="" /></div>' +
        '<div class="info"><h3>Protect ' + (requiredTier === 1 ? 'your' : 'all your') + ' Clutch' +
          (requiredTier === 1 ? '' : '&rsquo;s') + '<br/>for 3 years - ' + currencySymbol +
          (variant.price / 100).toFixed(2) + saveHtml + '</h3></div>' +
        '<div class="actions"><button type="button">Add Warrant' + (requiredTier === 1 ? 'y' : 'ies') + '</button></div>' +
      '</div>';

    banner.querySelector('button').addEventListener('click', function () {
      window.addingWarranty = true;
      window.ClutchWarrantySync.reconcile({ intent: 'attach' });
    });

    var mount = cartDrawer.querySelector('gamification');
    if (mount) mount.appendChild(banner);
  }

  function reconcile(options) {
    options = options || {};
    if (syncInProgress) return Promise.resolve();

    var cartDrawer = getCartDrawer();
    var intent = options.intent || 'reconcile';

    syncInProgress = true;

    return fetchCart()
      .then(function (cart) {
        var chargerCount = countEligibleChargers(cart.items);
        var requiredTier = getRequiredTier(chargerCount);
        var warrantyState = getWarrantyState(cart.items);
        var pdpAttach = window.pendingPdpWarrantyAttach === true;
        var needsAttach = pdpAttach || window.addingWarranty === true || intent === 'attach';
        var requiredVariant = getVariantByTier(requiredTier);

        cartDrawer && cartDrawer.querySelectorAll('.banner-warranty').forEach(function (node) {
          node.remove();
        });

        if (chargerCount === 0) {
          if (warrantyState.totalLineQty > 0) {
            return applyCartUpdates(buildVariantUpdates(0), cartDrawer).then(function (data) {
              refreshDrawer(data, cartDrawer);
            });
          }
          return null;
        }

        if (needsAttach && requiredVariant) {
          window.pendingPdpWarrantyAttach = false;
          window.addingWarranty = false;

          // Track the genuine attach (PDP checkbox or legacy widget), never on
          // background reconciles triggered by quantity changes.
          var shouldTrack = pdpAttach || options.trackAttach === true;

          if (warrantyState.coverage !== requiredTier || warrantyState.lineCount !== 1 || warrantyState.totalLineQty !== 1) {
            return applyCartUpdates(buildVariantUpdates(requiredTier), cartDrawer).then(function (data) {
              if (shouldTrack) trackAttach(requiredVariant);
              refreshDrawer(data, cartDrawer);
            });
          }

          if (shouldTrack) trackAttach(requiredVariant);
          return null;
        }

        if (warrantyState.coverage === 0) {
          if (
            cartDrawer &&
            cartDrawer.classList.contains('warranty-widget-enabled') &&
            !needsAttach
          ) {
            showUpsellBanner(chargerCount, cartDrawer);
          }
          return null;
        }

        if (
          warrantyState.coverage !== requiredTier ||
          warrantyState.lineCount > 1 ||
          warrantyState.totalLineQty !== 1
        ) {
          return applyCartUpdates(buildVariantUpdates(requiredTier), cartDrawer).then(function (data) {
            refreshDrawer(data, cartDrawer);
          });
        }

        return null;
      })
      .catch(function (error) {
        console.error('[ClutchWarrantySync]', error);
      })
      .finally(function () {
        syncInProgress = false;
      });
  }

  window.ClutchWarrantySync = {
    reconcile: reconcile,
    countEligibleChargers: countEligibleChargers,
    getRequiredTier: getRequiredTier,
    getVariantByTier: getVariantByTier,
    addEligibleProduct: addEligibleProduct
  };

  window.validateWarrantyItems = function () {
    return window.ClutchWarrantySync.reconcile({ intent: 'reconcile', trackAttach: false });
  };

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (event && event.source === 'warranty-sync') return;
    var attachPending = window.pendingPdpWarrantyAttach === true || window.addingWarranty === true;
    // Cart-side management can be disabled per the cart toggle, but an explicit
    // PDP/widget attach is still honored so the box still adds the item once.
    if (config.cartSyncEnabled === false && !attachPending) return;
    window.ClutchWarrantySync.reconcile({
      intent: attachPending ? 'attach' : 'reconcile',
      trackAttach: false
    });
  });
})();
